module.exports = require("html-minifier");


//////////////////
// WEBPACK FOOTER
// external "html-minifier"
// module id = 38
// module chunks = 0